import React from 'react';

import getColor from '../../../utils/getColor';
import styles from './styles/button-radius-50.module.css';

import SmallLoading from '../loading/SmallLoading';

export default function ButtonRadius50({ width, height, iconSize, status, icon, text, handleClick }) {
    const size = iconSize || '16px';

    return (
        <button
            className={styles.wrapper}
            style={{ width, backgroundColor: getColor(status) }}
            data-type={height}
            data-status={handleClick ? status : 'inactive'}
            onClick={handleClick}
        >
            {icon &&
                <div style={{ width: size, height: size, color: '#FFF' }}>
                    {icon}
                </div>
            }
            {text === 'loading' ? <SmallLoading size={size} /> : text}
        </button>
    );
}
